import { defineCollectionStore } from '@/utils/defineCollectionStore';

export const usePointsOfInterestStore = defineCollectionStore({
	id: 'pointsOfInterest',
	endpoint: '/api/points-of-interest',
	dataKey: 'data',
	errorLabel: 'Fetch Points of Interest Error: ',
	fetchName: 'fetchPointsOfInterest',
	extraState: () => ({
		data: null,
		archivedData: null,
	}),
	archive: {
		toggleName: 'toggleArchivedPoints',
		archivedDataKey: 'archivedData',
		archivedFetchName: 'fetchArchivedPointsOfInterest',
		archivedEndpoint: (year) => `/api/archive/${year}/points-of-interest`,
		getters: {
			pointsOfInterestData: 'data',
		},
	},
});
